module.exports = __webpack_public_path__ + "img/mascotte-pers.1d3f4216.jpg";